
import Vue from "vue";
import AppPaymentMethods from "@/components/account/PaymentMethods.vue";
import { IUpgradePricing, PaymentService } from "@/services/payment-service";
import { Mandat } from "@/models/payment/mandat";
import { Plan } from "@/utils/payments/plan";
import AppUpgradeCard from "@/components/account/UpgradeCard.vue";
import { Tier } from "../../utils/payments/tiers";
import { HttpError } from "../../utils/services/http-error";
import { AuthService } from "../../services/auth-service";
import AppBillingAddress from "@/components/account/BillingAddressEditCard.vue";
import { PlanModulePricingFactory } from "@/utils/payments/plan-module-pricing-factory";

export default Vue.extend({
	data() {
		return {
			price: null as IUpgradePricing | null,
			mandates: [] as Mandat[],
			plan: new Plan(),
		};
	},
	computed: {
		mandate():Mandat|null{
			if (this.mandates.length == 0){
				return null;
			}
			return this.mandates[0];
		},
		hasBillingAddress():boolean {
			return AuthService.wfCompany.WfOfflineID != "";
		},
	},
	watch: {
		plan: {
			deep: true,
			async handler(){
				try{
					if (AuthService.wfCompany.isPermanentlyActive()) {
						let result = await PaymentService.calculatePermanentUpgradePrice(this.plan);
						this.price = {pricing: result, startDate: new Date()};
					}else{
						this.price = await PaymentService.calculateUpgradePrice(this.plan.tier, this.plan.modules);
					}
				}catch(err){
					let error = err as HttpError;
					if (!error.isNetworkError){
						//await this.$wf.dialog(error.getText(), this.$ct("common.ok"), this.$ct("common.error"), "warning");
						this.$router.push("/account/price");
					}
				}
			}
		}
	},
	async created() {
		this.plan.tier = parseInt(this.$route.query.tier as string) || Tier.STARTER;
		this.plan.modules = (JSON.parse(((this.$route.query.modules as string || "[]"))) as any[]).map((m:any)=>PlanModulePricingFactory.create(m));
		this.mandates = await PaymentService.getMandates();
	},
	components: {
		AppPaymentMethods,
		AppUpgradeCard,
		AppBillingAddress
	},
	i18nEx: {
		componentPrefix: "views.AccountActivate"
	},
});
